import { classes } from '@theme/constants';
import { HTMLShopifySectionElement } from '@theme/html-custom-element';

class GuidesHero extends HTMLShopifySectionElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (!this.refs.slider) {
      return;
    }

    this.on('swiperautoplaytimeleft', this.refs.slider, this.handleSliderAutoplayTimeLeft.bind(this));
    this.on('swiperslidechange', this.refs.slider, this.handleSlideChange.bind(this), null, true);

    if (this.refs.button) {
      this.on('mouseover', this.refs.button.all, this.handleButtonMouseover.bind(this));
    }

    if (typeof this.refs.slider.initialize === 'function') {
      this.refs.slider.initialize();
    }
  }

  /**
   * Handles the slider autoplay time left event.
   * @param {Event} event - The event payload.
   * @param {object} event.detail
   */
  handleSliderAutoplayTimeLeft({ detail: [, , progress] }) {
    this.style.setProperty('--progress', `${((1 - progress) * 100).toFixed(1)}%`);
  }

  /**
   * Handles the slider slide change event.
   * @param {Event} event - The event payload.
   * @param {object} event.detail
   */
  handleSlideChange({ detail: [slider] } = { detail: [this.refs.slider.swiper] }) {
    requestAnimationFrame(() => {
      for (const element of this.refs.button.all) {
        element.classList.toggle(classes.active, slider.realIndex === parseInt(element.dataset.index0));
      }
    });
  }

  /**
   * Handles the button mouse over event.
   * @param {MouseEvent} event
   */
  handleButtonMouseover(event) {
    if (window.matchMedia('(hover: hover)').matches) {
      this.refs.slider.swiper.slideToLoop(parseInt(event.currentTarget.dataset.index0));
    }
  }

  onSectionLoad() {
    if (this.refs.slider) {
      this.refs.slider.initialize();
    }
  }

  onBlockSelect(event) {
    if (this.refs.slider) {
      this.refs.slider.swiper.slideToLoop(parseInt(event.target.dataset.index0), 0);

      if (this.refs.slider.swiper.autoplay.running) {
        this.refs.slider.swiper.autoplay.pause();
      }
    }
  }

  onBlockDeselect() {
    if (this.refs.slider) {
      if (this.refs.slider.swiper.autoplay.running) {
        this.refs.slider.swiper.autoplay.resume();
      }
    }
  }
}

if (!customElements.get('guides-hero')) customElements.define('guides-hero', GuidesHero);
